import React from "react";
import { useSelector } from "react-redux";
import { Bar } from "react-chartjs-2";
import { ChartData } from "chart.js";
import { useTranslation } from "react-i18next";

import { RootState } from "../../../../../store/store";
import ChartLegend from "../../ChartLegend/ChartLegend";
import { verticalChartOptions } from "../../../../../utils/charts/chartOptions";
import theme from "../../../../../components/styles/theme/theme";

const EmploymentValueChainStageChart: React.FC = () => {
  const { t } = useTranslation();
  const {
    statistics: { statisticsForSelectedCountry },
  } = useSelector((state: RootState) => state);

  const statisticsDataArray = [
    [
      null,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.employment_valueChainLink
          .theSystem_theCocaColaSystem,
      null,
    ],
    [
      null,
      null,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.employment_valueChainLink
          .downstream_suppliers_and_outlets,
    ],
    [
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.employment_valueChainLink
          .upstream_suppliers_and_outlets,
      null,
      null,
    ],
    [
      null,
      null,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.employment_valueChainLink
          .downstream_suppliers_and_outlets_suppliers,
    ],
    [
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.employment_valueChainLink
          .upstream_suppliers_and_outlets_suppliers,
      null,
      null,
    ],
  ].map((row) => row.map((value) => (value === 0 ? null : value)));
// @ts-ignore
  const data: ChartData<"bar"> = {
    labels: [
      t("charts.upstream_label"),
      t("charts.system_label"),
      t("charts.downstream_label"),
    ],
    datasets: [
      {
        label: t("charts.system_label") || "",
        data: statisticsDataArray[0],
        backgroundColor: theme.palette.secondary["600"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
      {
        label: t("charts.outlets_label") || "",
        data: statisticsDataArray[1],
        backgroundColor: theme.palette.primary["600"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
      {
        label: t("charts.first_tier_suppliers_label") || "",
        data: statisticsDataArray[2],
        backgroundColor: theme.palette.secondary["200"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
      {
        label: t("charts.outlets_suppliers_label") || "",
        data: statisticsDataArray[3],
        backgroundColor: theme.palette.primary["300"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },

      {
        label: t("charts.suppliers_suppliers_label") || "",
        data: statisticsDataArray[4],
        backgroundColor: theme.palette.secondary["50"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
    ],
  };

  return (
    <>
      <Bar options={verticalChartOptions("employment")} data={data} />
      <ChartLegend data={data} />
    </>
  );
};

export default EmploymentValueChainStageChart;
